import React from 'react'
import {
  rootRoute,
  friendsRoute,
  historyRoute,
  homeRoute,
  logoutRoute,
  loginRoute,
  profileRoute,
  walletRoute,
} from '../../../routes/routes'
import ChipNew from '../ChipNew'

const menuItems = {
  orderingMenu: [
    {
      copy: 'Restaurants',
      href: rootRoute.path,
    },
    {
      copy: 'Wallet',
      href: walletRoute.path,
    },
    {
      copy: 'Order History',
      href: historyRoute.path,
    },
    {
      copy: 'Profile',
      href: profileRoute.path,
    },
    {
      copy: 'Friends',
      href: friendsRoute.path,
    },
  ],
  foodsbyOne: [
    {
      copy: 'Foodsby One',
      href: process.env.REACT_APP_FOODSBY_ONE,
      external: true,
    },
  ],
  teamsMenu: [
    {
      copy: 'Create or join a team',
      href: `${homeRoute.path}?createTeam=true`,
      endAdornment: <ChipNew />,
    },
  ],
  adminMenu: [
    {
      copy: 'Foodsby Admin',
      href: `${process.env.REACT_APP_NEW_FOODSBY_ADMIN_URL}`,
      external: true,
    },
    {
      copy: 'Foodsby Admin (Old)',
      href: `${process.env.REACT_APP_FOODSBY_BASE_URL}/admin/login`,
      external: true,
    },
    {
      copy: 'Stats',
      href: process.env.REACT_APP_STATS_URL,
      external: true,
    },
  ],
  logout: [
    {
      copy: 'Sign Out',
      href: logoutRoute.path,
    },
  ],
  simpleMenu: [
    {
      copy: 'My Home',
      href: homeRoute.path,
    },
    {
      copy: 'Log In',
      href: loginRoute.path,
    },
  ],
}

export default menuItems
